<div class="dialog-header">

  <h2 mat-dialog-title>
    Bulk Booking
  </h2>

  <button
    mat-icon-button
    class="close-btn"
    (click)="cancel()">

    <mat-icon>
      close
    </mat-icon>

  </button>

</div>

<div class="success-overlay" *ngIf="showSuccessPopup">

  <div class="success-popup">

    <mat-icon class="success-icon">
      check_circle
    </mat-icon>

    <div class="success-message">

      Booking Successful

    </div>

    <div class="booking-id-section">

      <div class="booking-id-label">

        Booking ID

      </div>

      <div class="booking-id-value">

        {{bookingId}}

      </div>

    </div>

    <div class="success-button-row">

      <button
        class="pop-up-btn-blue success-ok-btn"
        (click)="closeSuccessPopup()">

        OK

      </button>

    </div>

  </div>

</div>

<mat-dialog-content class="bulk-dialog-content">

  <!-- ACTIVITIES -->
  <div class="section">

    <label class="fieldName">
      SERVICE
    </label>

    <select
      class="form-control"
      [(ngModel)]="selectedProductName"
      (change)="onProductChanged()">

      <option
        *ngFor="let product of products"
        [value]="product.productName">

        {{product.productName}}

      </option>

    </select>

  </div>

  <div
    class="error-message"
    *ngIf="venueError">

    {{venueError}}

  </div>

  <div *ngIf="!venueError">
    <!-- COURTS -->
    <div class="section">

      <label class="fieldName">
        VENUES
      </label>

      <div class="checkbox-block">

        <!--<label class="checkbox-row">

          <input
            type="checkbox"
            [(ngModel)]="selectAllCourts"
            (change)="onSelectAllCourts()">

          Select All

        </label>-->

        <label
          class="checkbox-row"
          *ngFor="let venue of availableVenues">

          <input
            type="checkbox"
            [checked]="selectedVenueIds.indexOf(venue.id) > -1"
            (change)="toggleVenue(venue.id)">

          {{venue.name}}

        </label>

      </div>

    </div>


    <!-- DATE -->
    <div class="date-grid">

      <div>

        <label class="fieldName">
          FROM
        </label>

        <input
          type="date"
          class="form-control"
          [(ngModel)]="fromDate">

      </div>

      <div>

        <label class="fieldName">
          TO
        </label>

        <input
          type="date"
          class="form-control"
          [(ngModel)]="toDate">

      </div>

    </div>

    <div
      class="section"
      *ngFor="let session of sessionConfigs; let i=index">

      <h5>

        Session {{i+1}}

      </h5>

      <label class="fieldName">

        DAYS

      </label>

      <div class="day-container">

        <label
          class="day-box"
          *ngFor="let day of session.days">

          <input
            type="checkbox"
            [checked]="session.selectedDays.indexOf(day) > -1"
            (change)="toggleSessionDay(session,day)">

          {{day}}

        </label>

      </div>

      <div class="time-grid">

        <div>

          <label class="fieldName">

            START TIME

          </label>

          <select
            class="form-control"
            [(ngModel)]="session.selectedStartTime"
            (change)="onSessionStartTimeChanged(session)">

            <option value="">
              Select Start Time
            </option>
            <option
              *ngFor="let time of session.startTimes"
              [value]="time">

              {{time}}
            </option>
          </select>

        </div>

        <div>

          <label class="fieldName">

            END TIME

          </label>

          <select
            class="form-control"
            [(ngModel)]="session.selectedEndTime">

            <option value="">
              Select End Time
            </option>

            <option
              *ngFor="let time of session.availableEndTimes"
              [value]="time">

              {{time}}

            </option>

          </select>

        </div>

      </div>

    </div>

  </div>
   <!--  DAYS
    <div class="section">

      <label class="fieldName">
        DAYS
      </label>

      <div class="day-container">

        <label
          class="day-box"
          *ngFor="let day of availableDays">

          <input
            type="checkbox"
            [checked]="selectedDays.indexOf(day) > -1"
            (change)="toggleDay(day)">

          {{day}}

        </label>

      </div>

    </div>


    &lt;!&ndash; TIME &ndash;&gt;
    <div class="time-grid">

      <div>

        <label class="fieldName">
          START TIME
        </label>

        <select
          class="form-control"
          [(ngModel)]="startTime"
          (change)="onStartTimeChanged()">

          <option value="">
            Select Start Time
          </option>

          <option
            *ngFor="let time of availableStartTimes"
            [value]="time">

            {{time}}

          </option>

        </select>

      </div>

      <div>

        <label class="fieldName">
          END TIME
        </label>

        <select
          class="form-control"
          [(ngModel)]="endTime">

          <option value="">
            Select End Time
          </option>

          <option
            *ngFor="let time of availableEndTimes"
            [value]="time">

            {{time}}

          </option>

        </select>

      </div>

    </div>-->

</mat-dialog-content>


<mat-dialog-actions align="end">

  <div *ngIf="!venueError" class="action-buttons">
    <button
      class="pop-up-btn-white"
      (click)="reset()">

      Reset

    </button>

    <button
      class="pop-up-btn-blue"

      (click)="bookNow()">

      Book In Bulk

    </button>
  </div>

</mat-dialog-actions>

<!--
<div class="bulk-bookings container">

  &lt;!&ndash; SERVICE &ndash;&gt;
  <div class="row">
    <div class="col-md-4 col-sm-12 form-group">

      <label class="fieldName">
        ACTIVITIES
      </label>

      <select
        class="form-control"
        [(ngModel)]="selectedProductName"
        (change)="onProductChanged()">

        <option
          *ngFor="let product of products"
          [value]="product.productName">

          {{product.productName}}

        </option>

      </select>

    </div>
  </div>


  &lt;!&ndash; COURTS &ndash;&gt;
  <div class="row mt-4">

    <div class="col-md-6">

      <label class="fieldName">
        COURT
      </label>

      <div class="checkbox-block">

        <label class="checkbox-row">

          <input
            type="checkbox"
            [(ngModel)]="selectAllCourts"
            (change)="onSelectAllCourts()">

          Select All

        </label>

        <label
          class="checkbox-row"
          *ngFor="let venue of availableVenues">

          <input
            type="checkbox"
            [checked]="selectedVenueIds.indexOf(venue.id) > -1"
            (change)="toggleVenue(venue.id)">

          {{venue.name}}

        </label>

      </div>

    </div>

  </div>


  &lt;!&ndash; DATE &ndash;&gt;
  <div class="row mt-4">

    <div class="col-md-3">

      <label class="fieldName">
        FROM
      </label>

      <input
        type="date"
        class="form-control"
        [(ngModel)]="fromDate">

    </div>

    <div class="col-md-3">

      <label class="fieldName">
        TO
      </label>

      <input
        type="date"
        class="form-control"
        [(ngModel)]="toDate">

    </div>

  </div>


  &lt;!&ndash; DAYS &ndash;&gt;
  <div class="row mt-4">

    <div class="col-md-12">

      <label class="fieldName">
        DAY
      </label>

      <div class="day-container">

        <label
          class="day-box"
          *ngFor="let day of days">

          <input
            type="checkbox"
            [checked]="selectedDays.indexOf(day) > -1"
            (change)="toggleDay(day)">

          {{day}}

        </label>

      </div>

    </div>

  </div>


  &lt;!&ndash; TIME &ndash;&gt;
  <div class="row mt-4">

    <div class="col-md-3">

      <label class="fieldName">
        START TIME
      </label>

      <input
        type="time"
        class="form-control"
        [(ngModel)]="startTime">

    </div>

    <div class="col-md-3">

      <label class="fieldName">
        END TIME
      </label>

      <input
        type="time"
        class="form-control"
        [(ngModel)]="endTime">

    </div>

  </div>


  &lt;!&ndash; IGNORE UNAVAILABLE &ndash;&gt;
  <div class="row mt-4">

    <div class="col-md-12">

      <label>

        <input
          type="checkbox"
          [(ngModel)]="ignoreUnavailableSlots">

        Ignore unavailable slots

      </label>

    </div>

  </div>


  &lt;!&ndash; BUTTONS &ndash;&gt;
  <div class="row mt-5">

    <div class="col-md-12">

      <button
        class="btn btn-secondary"
        (click)="reset()">

        Reset

      </button>

      <button
        class="btn btn-primary"
        style="margin-left:20px"
        (click)="bookNow()">

        Book in bulk

      </button>

    </div>

  </div>

</div>
-->
